import React from 'react';

import styled from 'styled-components';

import ProjectCardLoader from './components/ProjectCardLoader';
import { paperPadding } from 'styles/commonStyles';

const Wrapper = styled.div<{ $hasMaxWidth: boolean }>`
  ${paperPadding};
  flex: 1;
  display: flex;
  flex-direction: column;
  padding-bottom: 84px;
  max-width: ${(props) => (props.$hasMaxWidth ? '1100px' : 'initial')};
`;

const Content = styled.div`
  margin-top: 20px;
  flex: 1;
`;

const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
  gap: 24px;
  margin-top: 20px;
`;

interface PageProps {
  title: string;
  isLoading?: boolean;
  isError?: boolean;
  isGrid?: boolean;
  hasMaxWidth?: boolean;
  children?: React.ReactNode;
}

const Paper = ({ isGrid = false, hasMaxWidth = true, isLoading, isError, children }: PageProps) => {
  if (isError) {
    return <div>에러가 발생했습니다.</div>;
  }

  return (
    <Wrapper $hasMaxWidth={hasMaxWidth}>
      {isGrid && <CardGrid>{isLoading ? <ProjectCardLoader /> : children}</CardGrid>}
      {!isGrid && (isLoading ? <></> : <Content>{children}</Content>)}
    </Wrapper>
  );
};

export default Paper;
